import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RadioBox from "../../Pages/Playlist/radioBox";
import Creators from "../../Pages/Playlist/Creators";
import Languages from "../../Pages/Playlist/Languages";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Categories from "../../Pages/Playlist/Categories";
import { rating } from "../../Pages/Playlist/Rating";
import { useTheme } from "../../Context/ThemeContext";
const useStyles = makeStyles({
  root: {
    width: "100%",
    border: "none",
    outline: "none",
  },
  summary: {
    backgroundColor: "transparent",
  },
  main: {
    width: "70%",
    margin: "auto",
    minHeight: "100vh",
  },
  heading: {
    fontSize: "24px",
    fontFamily: "Epilogue",
    padding: "10px",
    marginBottom: "10px",
  },
  searchkey: {
    fontFamily: "Epilogue",
    fontStyle: "italic",
    paddingRight: "10px",
    background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  filltext: {
    fontFamily: "Epilogue",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
    padding: "10px",
  },
  details: {
    height: "max-content",
    overflowY: "scroll",
  },
  maindiv: {
    maxHeight: "80%",
  },
});

function FilterModal({
  open,
  setOpen,
  names,
  filters,
  category,
  creators,
  handleFilters,
  loadFilteredPlaylists,
  handleRating,
  pagetype,
}) {
  const classes = useStyles();
  const { theme } = useTheme();
  const handleClose = () => setOpen(false);

  const style = {
    width: "240px",
    maxWidth: "100vw",
    position: "relative",
    top: "50%",
    background: theme === "dark" ? "var(--bg-secondary)" : "white",
    borderRadius: "10px",
    left: "0",
    margin: "auto",
    transform: "translate(0, -50%)",
    overflowY: "scroll",
    color: theme === "dark" ? "var(--text-primary)" : "black",
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className={classes.maindiv}>
            <p
              className={classes.filltext}
              style={{
                color: theme === "dark" ? "var(--text-primary)" : "black",
              }}
            >
              Filters
            </p>
            <Accordion
              className={classes.root}
              style={{ background: "transparent" }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    style={{ color: theme === "dark" ? "white" : "black" }}
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={classes.summary}
              >
                <Typography
                  style={{ color: theme === "dark" ? "white" : "black" }}
                >
                  Ratings
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <RadioBox
                  rating={rating}
                  handleFilters={(filters) => handleFilters(filters, "rating")}
                  filters={filters}
                />
              </AccordionDetails>
            </Accordion>

            {/* {pagetype !== "subcategory" && (
              <Accordion className={classes.root}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Categories</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Categories
                    categories={category}
                    filters={filters}
                    handleFilters={(filters) =>
                      handleFilters(filters, "category")
                    }
                    handleSubFilters={(filters) =>
                      handleFilters(filters, "subCategory")
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )}
            <Accordion className={classes.root}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Creators</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <Creators
                  handleFilters={(filters) => handleFilters(filters, "creator")}
                  creators={creators}
                  filters={filters}
                />
              </AccordionDetails>
            </Accordion> */}
            <Accordion
              className={classes.root}
              style={{ background: "transparent" }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    style={{ color: theme === "dark" ? "white" : "black" }}
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  style={{ color: theme === "dark" ? "white" : "black" }}
                >
                  Languages
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.details}>
                <Languages
                  handleFilters={(filters) =>
                    handleFilters(filters, "language")
                  }
                  languages={names}
                  filters={filters}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default FilterModal;
